// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__15zc8","slick-next":"CustomSlider_slick-next__3usYu"};